import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "./iwarehouses_style.css";
import { FaUndo } from "react-icons/fa";

function DeletedWarehouses ({ setUpdateTrigger, updateTrigger }) {

    const [deletedWarehouses, setDeletedWarehouses] = useState([]);

    const getDeletedWarehouses = async (id) => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/warehouses/getAllDeleted`, {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                },
            });
            if (res.status === 200) {
                setDeletedWarehouses(res.data.data);
            } else {
                Swal.fire("Error", "Hubo un error al obtener los datos eliminados", "error");
            }
        } catch (error) {
            Swal.fire("Error", "Hubo un error al obtener los datos eliminados", "error");
        }
    };

    const restoreWarehouse = async (id) => {
        try {
            const result = await Swal.fire({
                title: "¿Estás seguro?",
                text: "¿Quieres restaurar este elemento?",
                icon: "warning",
                showDenyButton: true,
                confirmButtonText: "Sí, restaurar",
                denyButtonText: "No, cancelar",
                reverseButtons: true,
                buttonsStyling: true,
            });

            if (result.isConfirmed) {
                const response = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/warehouses/restore/${id}`, {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                    },
                });

                Swal.fire("¡Restaurado!", "El elemento ha sido restaurado.", "success");
                setUpdateTrigger(!updateTrigger);
                getDeletedWarehouses();
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire("Cancelado");
            }
        } catch (error) {
            Swal.fire("Error", "Hubo un error", "error");
        }
    };

    useEffect(() => {
        getDeletedWarehouses();
    }, [updateTrigger]);

    return (
        <div className='table-responsive'>
            <h3 className="mb-4">Almacenes Eliminados</h3>
            <table className="table table-inverse table-hover table-striped table-bordered dataTable no-footer" role="grid">
                <thead>
                    <tr>
                        <th>Nombre</th>
                        <th>Acrónimo</th>
                        <th>N° de almacén</th>
                        <th>Correo</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {deletedWarehouses.map((warehouse) => (
                        <tr key={warehouse.id} data-master-id={warehouse.id}>
                            <td>{warehouse.name}</td>
                            <td>{warehouse.code}</td>
                            <td>{warehouse.number}</td>
                            <td>{warehouse.email}</td>
                            <td>
                                <FaUndo className='restoreButton' onClick={() => { restoreWarehouse(warehouse.id) }} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );

}

export default DeletedWarehouses;